module.exports = __webpack_public_path__ + "img/app4.075e20f0.png";